import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// iOS Debug: Log app start
console.log('[iOS-DEBUG] 🚀🚀🚀 App starting...');
console.log('[iOS-DEBUG] Platform:', navigator.platform);
console.log('[iOS-DEBUG] UserAgent:', navigator.userAgent?.substring(0, 100));

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('[iOS-DEBUG] React root created, rendering App...');
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
console.log('[iOS-DEBUG] App render called');
